/*
Compare Backpacks
*/
$(document).ready(function(){
  const setData = function (data, columnIndex) {
    for (let index = 0; index < data.length; index++) {
      let key = data[index][0];
      let value = data[index][1];
      $('[data-key="' + key + '"]').each(function(){
        $(this).children().eq(columnIndex).html(value);
      });
    }
  };
  if( typeof window.comparisonData !== 'undefined' ){
    let defaultProductKey = window.comparisonData['default'];
    $('.comparison-options').eq(0).val(defaultProductKey);
    setData(window.comparisonData[defaultProductKey],1);
    
    $('.comparison-options').on('change',function(){
      var productKey = $(this).val();
      if ($(this).val() in window.comparisonData) {
        setData(window.comparisonData[productKey],$(this).closest('th').index());
      }
    });
  }
}); 

/*
Comparison Guide
*/
$('.product-selector').on('change', function(){
	let col = $(this).data('column');
	$(`.facet-${col}`).html('');
	$(`.col-${col}-title`).html('');
	$(`.col-${col}-options`).html('');
	$(`.col-${col}-price`).html('');
	$(`.col-${col}-image`).hide();
	$(`.col-${col}-link`).hide();
	$(`.col-${col}-explore`).hide();
	
	if (!$(this).val()) {
		return;
	}

	let v = $(this).val().split('|');
	let handle = v[0];
	let variantTitle = v[1] ? v[1] : 'default title';
	let productData = window.compareData[handle];
	// handle Seville variant titles
	if (variantTitle === '13' || variantTitle === '15') {
		variantTitle = variantTitle + '"';
	}
	var data = productData.find(variant => {
		return variant.title === variantTitle
	});

	let colorsStr = data.count === 1 ? 'color' : 'colors';
	$(`#BaseWidth-${col}`).html(data.BaseWidth);
	$(`#Depth-${col}`).html(data.Depth);
	$(`#Height-${col}`).html(data.Height);
	$(`#Volume-${col}`).html(data.Volume);
	$(`#Weight-${col}`).html(data.Weight);
	$(`#AirlineCarryOn-${col}`).html(data.AirlineCarryOn);
	$(`#HandleDropLength-${col}`).html(data.HandleDropLength);
	$(`#StrapLength-${col}`).html(data.StrapLength);
	$(`#FrontZipperPocketHeight-${col}`).html(data.FrontZipperPocketHeight);
	$(`#LinearInches-${col}`).html(data.LinearInches);
	$(`#UseCases-${col}`).html(data.UseCases);

	let materialsHtml = '<ul class="materials-list">';
	data.Materials.forEach(material => {
		materialsHtml += `<li><img src="${material.img}" width="100" height="100" alt="" />${material.name}</li>`;
	});
	materialsHtml += '</ul>';
	$(`#materials-${col}`).html(materialsHtml);
	
	$(`#LaptopSize-${col}`).html(data.LaptopSize);
	$(`#LaptopWidth-${col}`).html(data.LaptopWidth);
	$(`#LaptopHeight-${col}`).html(data.LaptopHeight);
	$(`#LaptopDepth-${col}`).html(data.LaptopDepth);

	$(`.col-${col}-title`).html(data.productTitle);
	$(`.col-${col}-options`).html(`Available ${data.count} ${colorsStr}`);
	$(`.col-${col}-image`).attr('src', data.image).show();
	$(`.col-${col}-link`).attr('href', data.link).show();
	if (data.explore) {
		$(`.col-${col}-explore`).attr('href', data.explore).show();
	}
});

function resetFilters(){
	$('.product-selector option').show();
	$('#active-filter-count').html('');
	$('#clear-comparison-filters').fadeOut();
	$('#comparison-filters-actions .clear-filters').hide();
	$('.product-selector').val('').trigger('change');
}

$('.comparison-filter').on('click', function(e){
	e.preventDefault();
	let activeFilters = [];
	$(this).toggleClass('active');
	$('.comparison-filter').each(function(){
		if ($(this).hasClass('active')) {
			activeFilters.push($(this).data('value'));
		}
	});
	if (!activeFilters.length) {
		resetFilters();
		return;
	}
	if ($(window).width() >= 768) {
		$('#clear-comparison-filters').fadeIn();
	} else {
		$('#comparison-filters-actions .clear-filters').show();
	}
	$('.product-selector option').hide().removeClass('active');
	$('.product-selector option').each(function(){
		let c = $(this).attr('class').split(' ');
		let matches = c.filter(value => activeFilters.includes(value));
		let $parent = $(this).closest('.product-selector');
		if (matches.length) {
			// non-empty matches means this option has a class in the activeFilters array
			$(this).show();
			$(this).addClass('active');
		}
		if ($parent.val() === $(this).attr('value') && !$(this).hasClass('active')) {
			$parent.val('').trigger('change');
		}
		if ($(this).hasClass('default')) {
			$(this).show();
		}
	});
	$('#active-filter-count').html(` (${activeFilters.length})`);
});

$('.clear-filters').on('click', function(e){
	e.preventDefault();
	$('.comparison-filter').removeClass('active');
	resetFilters();
});

$('#open-filter-panel').on('click', function(e){
	e.preventDefault();
	$('#comparison-filters').addClass('shown');
});

$('.close-filters').on('click', function(e){
	e.preventDefault();
	$('#comparison-filters').removeClass('shown');
});

if (window.location.hash) {
	$(`[data-value="${window.location.hash.replace('#','')}"]`).click();
}